import React, { useEffect, useState } from "react";
import IncomeChart from "../../IncomeChart/IncomeChart";
import ClientsBySource from "./ClientsBySource";
import AnalyticsCards from "./AnalyticsCards";
import NetPromoterScore from "./NetPromoterScore";
import TopServicesStats from "./TopServicesStats";
import ByWorkers from "./ByWorkers";
import { REST_API_URL } from "../../api/config";
import { buildHeaders } from "../../api/buildHeaders";

const API_URL = REST_API_URL;

export default function Analytics() {
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    const token =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");

    if (!token) return;

    const fetchUserType = async () => {
      try {
        const headers = buildHeaders();

        const res = await fetch(`${API_URL}/auth/userinfo/`, {
          headers,
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setUserType(data?.user?.status || null);
      } catch (err) {
        console.error("❌ Error fetching user type:", err);
      }
    };

    fetchUserType();
  }, []);

  const showByWorkers = userType === "salon";

  return (
    <main className="flex flex-1 flex-col bg-[#f9fafc] w-full">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6 items-stretch">
        <div className="col-span-2 h-full flex flex-col">
          <IncomeChart />
        </div>

        <div className="lg:col-span-1 h-full flex flex-col">
          <ClientsBySource />
        </div>
      </div>

      <div
        className={`grid grid-cols-1 ${
          showByWorkers ? "lg:grid-cols-3" : "lg:grid-cols-2"
        } gap-6 mb-6 w-full`}
      >
        <TopServicesStats />
        <NetPromoterScore />
        {showByWorkers && <ByWorkers />}
      </div>

      <div className="w-full">
        <AnalyticsCards />
      </div>
    </main>
  );
}
